import { format, parseISO } from 'date-fns'
import logger from '@/logger/index'

export const mixin = {
  props: {
    classes: {
      type: Object,
      default: null,
    },
  },

  data () {
    return {
      DATE_FORMAT: 'dd/MM/yyyy',
      $classes: {},
    }
  },

  computed: {
    $media () {
      return {
        mobile: this.$mq === 'mobile',
        tablet: this.$mq === 'tablet',
        desktop: this.$mq === 'desktop',
      }
    },
  },

  watch: {
    $style () {
      this.createClasses()
    },
  },

  methods: {
    createClasses () {
      this.$classes = this.$style || {}
      if (this.classes) {
        Object.keys(this.classes).map(key => {
          if (this.$classes[key]) {
            this.$classes[key] = `${this.$classes[key]} ${this.classes[key]}`
          }
        })
      }
    },

    formatDate (date, formatString = this.DATE_FORMAT) {
      return format(parseISO(date), formatString)
    },

    formatDecimal (value, decimalPlaces = 2) {
      return Number((value).toFixed(decimalPlaces))
    },

    copyToClipboard (text) {
      navigator.clipboard.writeText(text).then(() => {
        logger.debug('Token copiado para a área de transferência')
      }).catch((err) => {
        logger.debug('Erro ao copiar para a área de transferência:', err)
      })
    },
  },

  created () {
    this.createClasses()
  },
}
